import React, { useState, useEffect } from "react";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";
import {
  get_cookies,
  isLoggedIn,
  timeZoneChanger,
} from "../../../components/Cookies/Cookies";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Preloader from "../../../components/Preloader/Preloader";
import { useParams, useHistory } from "react-router-dom";
import MessageBox from "../../../components/MessageBox/MessageBox";
import { Breadcrumbs, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  field: {
    width: "100%",
    marginBottom: "1rem",
  },
  autoComplete: {
    width: "100%",
    marginTop: "0",
    marginBottom: "0.5rem",
  },
  date: {
    width: "100%",
    marginBottom: "1rem",
  },
  buttonContainer: {
    textAlign: "right",
  },
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #33993312",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#9f9f9f",
  },
  root: {
    "&$disabled": {
      color: "#f2f2f2",
    },
  },
  disabled: {},
});

const SalesReturn = () => {
  const classes = useStyles();
  const x = 0;
  useEffect(() => {
    //
    timeZoneChanger(setSelectedDate);
    isLoggedIn();
  }, [x]);

  useEffect(() => {
    //
    getShippingList();
    getWarehouseList();
  }, []);

  const [selectedDate, setSelectedDate] = React.useState(null);
  const [shipping, setShipping] = useState(null);
  const [warehouse, setWarehouse] = useState(null);
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);

  const [trantype, setTrantype] = useState("");
  const [shippingId, setShippingId] = useState(0);
  const [warehouseId, setWarehouseId] = useState(0);
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  const [idNo, setIdNo] = useState("");
  const [defaultWarehouse, setDefaultWarehouse] = useState(null);

  const getShippingList = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/get_shipping_list", {
        params: {
          jc_user_id_no: branchIdNo, //branchIdNo
        },
      })
      .then((res) => {
        setShipping(res.data.data);
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };
  const getWarehouseList = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "/get_warehouse_list", {
        params: {
          jc_user_id_no: branchIdNo, //branchIdNo
        },
      })
      .then((res) => {
        setWarehouse(res.data.data);
        res.data.data.some(function (entry, i) {
          if (entry.description == "HQ Warehouse") {
            //console.log(i);
            //console.log(entry.id);
            setDefaultWarehouse(i);
            setWarehouseId(entry.id);
            return true;
          }
        });
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };

  const selectShippingProps = {
    options: shipping,
    getOptionLabel: (option) => option.description,
  };

  const selectLocationProps = {
    options: warehouse,
    getOptionLabel: (option) => option.description,
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  let history = useHistory();

  const validate_idno = async () => {
    setBtnDisabled(true);
    await axios
      .get(process.env.REACT_APP_API_URL + "/sales_return_form", {
        params: {
          idno: idNo,
          jc_user_id_no: get_cookies("branchidno"),
          trandate: selectedDate,
          shipping: shippingId,
          warehouse: warehouseId,
          curcode: get_cookies("curcode"),
        },
      })
      .then((res) => {
        history.push(
          "/sales/sales-return-information/" +
            shippingId +
            "/" +
            warehouseId +
            "/" +
            idNo +
            "/" +
            format(new Date(selectedDate), "yyyy-MM-dd")
        );
      })
      .catch((error) => {
        // console.log(error.message);
        setShowMsgBox(true);
        setMsg("ID No not found");
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  const ColorButton = withStyles(() => ({
    root: {
      color: "#fff",
      backgroundColor: "#4caf50",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#4caf50",
      },
    },
  }))(Button);

  useEffect(() => {
    if (idNo && selectedDate && shippingId && warehouseId) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [idNo, selectedDate, shippingId, warehouseId]);

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        <Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Sales Return</Typography>
				</Breadcrumbs>
      </div>
      {shipping && warehouse && defaultWarehouse != null ? (
        <div className="page-container">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                <Grid item xs={8}>
                  <div className={classes.title}>Sales Return</div>
                </Grid>
                <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                <Grid item xs={2} className={classes.buttonContainer}></Grid>
                <Grid container spacing={2}>
                  <Grid item xs="12" lg="4" xl="3">
                    <form noValidate autoComplete="off">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          variant="inline"
                          format="MMM dd, yyyy"
                          id="date-picker-inline"
                          label="Date Return"
                          value={selectedDate}
                          onChange={handleDateChange}
                          inputVariant="outlined"
                          margin="normal"
                          className={classes.date}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          inputProps={{ readOnly: "true" }}
                        />
                      </MuiPickersUtilsProvider>
                      <TextField
                        id="outlined-basic"
                        label="Enter ID No."
                        variant="outlined"
                        type="text"
                        className={classes.field}
                        value={idNo} //to avoid label overlapping bug
                        onChange={(e) => {
                          setIdNo(e.target.value);
                        }}
                      />
                      <Autocomplete
                        {...selectShippingProps}
                        id="auto-complete-1"
                        autoComplete
                        includeInputInList
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Shipping"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, newValue) => {
                          if (!newValue == "" || !newValue == null) {
                            //console.log(newValue.description);
                            setShippingId(newValue.id);
                          } else {
                            setShippingId(null);
                          }
                        }}
                      />
                      <Autocomplete
                        {...selectLocationProps}
                        id="auto-complete-2"
                        defaultValue={warehouse[defaultWarehouse]}
                        autoComplete
                        includeInputInList
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            margin="normal"
                            label="Select Location"
                            variant="outlined"
                          />
                        )}
                        onChange={(event, newValue) => {
                          if (!newValue == "" || !newValue == null) {
                            //console.log(newValue.description);
                            setWarehouseId(newValue.id);
                          } else {
                            setWarehouseId(null);
                          }
                        }}
                      />
                    </form>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </Card>
          <div className={classes.buttonContainer}>
            {/* <NavLink
						to={
							"/sales/sales-return-information/"+shippingId +"/" +warehouseId +"/" +idNo +"/" +format(selectedDate, "yyyy-MM-dd")
						}
					> */}
            <ColorButton
              disabled={btnDisabled}
              variant="contained"
              color="primary"
              onClick={() => {
                validate_idno();
              }}
              classes={{
                root: classes.root,
                disabled: classes.disabled,
              }}
            >
              Proceed
            </ColorButton>
            {/* </NavLink> */}
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default SalesReturn;
